'use client';

import type { TrailId } from '@alltrails/types/TrailId';
import useInstallPrompt from '@alltrails/install-prompt/hooks/useInstallPrompt';
import InstallBanner from '@alltrails/install-prompt/components/InstallBanner';

type TrailInstallPromptProps = {
  isBot: boolean;
  trailId: TrailId;
};

const TrailInstallPrompt = ({ isBot, trailId }: TrailInstallPromptProps) => {
  const [isBannerOpen, setIsBannerOpen] = useInstallPrompt('banner', !isBot);

  if (isBot) {
    return null;
  }

  return (
    <InstallBanner
      isOpen={isBannerOpen}
      deeplinkData={{ pageId: trailId, pageType: 'trail' }}
      onRequestClose={() => setIsBannerOpen(false)}
      promptLocation="trail page"
    />
  );
};

export default TrailInstallPrompt;
